exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page {\r\n    max-width: 95%;\r\n    height: 100%;\r\n    margin: 0 auto;\r\n    padding: 40px 0 0;\r\n    background-color: #fff;\r\n    border-left: 1px solid #DDDDDD;\r\n    border-right: 1px solid #DDDDDD;\r\n    border-bottom: 1px solid #DDDDDD;\r\n  }\r\n  \r\n  .container  {\r\n    margin-top: 50px;\r\n    margin-bottom: 30px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .heading {\r\n    margin: 30px 0;\r\n  }\r\n  \r\n  .form-group {\r\n    max-width: 500px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n  \r\n  button[type=\"submit\"] {\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .note {\r\n    text-align: center;\r\n    margin: 20px 0;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/The-Top/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main